export function passwordIs8CharsWithNumAndCapitalLetter(str: string): boolean {
  const pattern = new RegExp(/^(?=.*\d)(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/);

  return pattern.test(str);
}
